import { render, staticRenderFns } from "./serve-upload.vue?vue&type=template&id=df8063ae&"
import script from "./serve-upload.vue?vue&type=script&lang=js&"
export * from "./serve-upload.vue?vue&type=script&lang=js&"
import style0 from "./serve-upload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports